"use client";
import { useIsMobile } from "@/utils/useIsMobile";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import React from "react";

type BarData = {
  year: string;
  value: number;
};

type YearlyBarChartReturnsProps = {
  data: BarData[];
};

const YearlyBarChartReturns: React.FC<YearlyBarChartReturnsProps> = ({ data }) => {
  const isMobile = useIsMobile();

  const chartOptions: Highcharts.Options = {
    chart: {
      type: "column",
      backgroundColor: "transparent",
      height: 290,
    },
    title: {
      text: undefined,
    },
    credits: {
      enabled: false,
    },
    xAxis: {
      categories: data.map((item) => item.year),
      labels: {
        style: {
          fontWeight: "normal",
          fontSize: "14px",
          fontFamily: "Inter, sans-serif",
        },
      },
      lineColor: "transparent",
      lineWidth: 0,
      tickColor: "transparent",
      tickWidth: 0,
    },
    yAxis: {
      title: { text: undefined },
      labels: {
        enabled: false,
      },
      gridLineColor: "transparent",
      gridLineWidth: 0,
      lineColor: "transparent",
      lineWidth: 0,
      tickColor: "transparent",
      tickWidth: 0,
    },
    plotOptions: {
      column: {
        borderRadius: 6,
        dataLabels: {
          enabled: true,
          inside: false,
          useHTML: true,
          formatter: function () {
            const value = this.y ?? 0;
            const color = value < 0 ? "#f88476" : "#202020";
            return `<span style="color:${color};font-weight:500;font-family:Inter,sans-serif">${value}%</span>`;
          },
        },
      },
    },
    tooltip: {
      enabled: false,
    },
    legend: {
      enabled: false,
    },
    series: [
      {
        type: "column",
        name: "Performance",
        data: data.map((item) => ({
          y: item.value,
          color: item.value < 0 ? "#f88476" : "#5db2a2",
        })),
      },
    ],
    responsive: {
      rules: isMobile
        ? [
            {
              condition: {
                maxWidth: 750,
              },
              chartOptions: {
                xAxis: {
                  labels: {
                    style: {
                      fontSize: "10px",
                    },
                  },
                },
              },
            },
          ]
        : [],
    },
  };

  return <HighchartsReact highcharts={Highcharts} options={chartOptions} />;
};

export default YearlyBarChartReturns;
